import ForgotPasswordEmailOrPhone, {
  EMAIL,
  PHONE,
} from "./ForgotPasswordEmailOrPhone";

export { EMAIL, PHONE };
export default ForgotPasswordEmailOrPhone;
